import { CheckPicker } from "rsuite";
import WidgetSection from "./WidgetSection";
import ManageItems from "../../ManageItems/ManageItems";
import { Field, Section } from "../../../types/TenantInterfaces";

interface Props {
  section: Section;
  i: number;
  reorderSection: any;
  sectionsLength: number;
  editMode: boolean;
  removeSection: any;
  infoChange: any;
  currentModule: any;
  fieldListUpdate: (newOrder: string[], section: any) => void;
  onSelectField: (field: string) => void;
  removeField: (section: any, field: { Field: string } | "All") => void;
  selectedFields: string[];
  fieldOptions: any;
}

// Section used in RecordDetailLayout when the section type is RecordSummarySection
export const RecordSummarySection = ({
  section,
  selectedFields,
  i,
  reorderSection,
  sectionsLength,
  editMode,
  infoChange,
  fieldListUpdate,
  onSelectField,
  removeSection,
  removeField,
  currentModule,
  fieldOptions,
}: Props) => {
  if (section.Type !== "RecordSummarySection") return null;

  const sectionFields = section?.Fields?.map((f) =>
    typeof f?.Field === "string" ? f?.Field : f.Field
  );

  const isStringArray = typeof section?.Fields?.[0]?.Field === "string";

  return (
    <WidgetSection
      editMode={editMode}
      reorderSection={reorderSection}
      section={section}
      index={i}
      sectionsLength={sectionsLength}
      removeSection={removeSection}
      infoChange={infoChange}
      body={
        <>
          <h5 className="text-uppercase text-dark">Fields</h5>
          <div>
            {editMode ? (
              <>
                <ManageItems
                  items={sectionFields as Field[]}
                  isStringArray={isStringArray}
                  itemKey={undefined}
                  idKey={isStringArray ? undefined : "APIName"}
                  nameKey={isStringArray ? undefined : "Name"}
                  onDelete={({ id }) => removeField(section, { Field: id })}
                  onReorder={({ newOrder }) =>
                    fieldListUpdate(newOrder, section)
                  }
                />
                <CheckPicker
                  className="mt-4"
                  placeholder="Select Layout Fields"
                  data={
                    fieldOptions.length > 0
                      ? fieldOptions
                      : currentModule?.Fields
                  }
                  labelKey="Name"
                  valueKey="APIName"
                  value={selectedFields}
                  block
                  preventOverflow
                  onSelect={(_, f) => {
                    onSelectField(f?.APIName);
                  }}
                  onClean={() => removeField(section, "All")}
                />
              </>
            ) : (
              <div>
                {section.Fields.map((f, i) => {
                  const name =
                    typeof f?.Field === "string" ? f?.Field : f?.Field?.Name;
                  const apiName =
                    typeof f?.Field === "string" ? f?.Field : f?.Field?.APIName;

                  return (
                    <div key={i}>
                      <h4 className="mb-0">{name}</h4>
                      <p
                        className="mb-0 text-muted"
                        style={{
                          lineHeight: 1.25,
                        }}
                      >
                        <small>{apiName}</small>
                      </p>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </>
      }
    />
  );
};
